import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Input, OnDestroy } from '@angular/core';
import { ActionTabletContext } from '../../model/action-tablet-context';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { StructureSelectionService } from '../../../../../common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from '../../../../../common/structure-selection/structure-selection.model';
import { Station } from '../../../../../client/model/station';

import { Subscription } from 'rxjs';

const STORAGE_KEY = 'app-action-tablet.settings';

@Component({
    selector: 'app-action-tablet-header',
    templateUrl: './action-tablet-header.component.html',
    styleUrls: ['./action-tablet-header.component.scss'],
    standalone: false
})
export class ActionTabletHeaderComponent implements OnDestroy {

  actionTabletContext: ActionTabletContext;
  actionTabletContextSubscription: Subscription;

  @Input('actionTabletContext') set setSacClientContext(actionTabletContext: ActionTabletContext) {
    this.actionTabletContext = actionTabletContext;

    this.actionTabletContextSubscription = actionTabletContext.contextReady.subscribe(() => {
      this.restoreSelectionFromStorage();
      if (actionTabletContext.selectedStations == null || actionTabletContext.selectedStations.length === 0) {
        this.chooseStation();
      }
    }
    );
  }

  constructor(
    private componentSelectionStorageService: ComponentSelectionStorageService,
    private structureSelectionService: StructureSelectionService,
    private tmcContextService: TmcContextService
  ) { }

  ngOnDestroy() {
    if (this.actionTabletContextSubscription) {
      this.actionTabletContextSubscription.unsubscribe();
    }
  }

  private restoreSelectionFromStorage() {
    const settings = this.componentSelectionStorageService.getWidgetSelection(STORAGE_KEY, this.actionTabletContext.widgetIdentifier);
    if (settings != null && settings.selectedStations != null) {
      this.actionTabletContext.selectedStations = settings.selectedStations;
      if (this.actionTabletContext.selectedStations.length > 0) {
        this.actionTabletContext.currentlyActiveStation = this.findStoredSelection();
      }
    }
  }

  private storeSettings() {
    const settings: any = {
      selectedStations: this.actionTabletContext.selectedStations,
      currentlyActiveStation: this.actionTabletContext.currentlyActiveStation
    };
    this.componentSelectionStorageService.saveWidgetSelection(STORAGE_KEY, this.actionTabletContext.widgetIdentifier, settings);
  }

  public chooseStation() {

    this.structureSelectionService.selectStation(new StructureSelection()).subscribe(
      value => {
        const selection: StructureSelection = value;

        let selectedStation: Station;
        if (selection.stationId != null) {
          selectedStation = this.tmcContextService.findStationById(selection.stationId);
        }

        if (selectedStation != null) {
          if (this.isStationAlreadyInContext(selectedStation)) {
            this.actionTabletContext.currentlyActiveStation = selectedStation.id;
          } else { // otherwise add it
            this.actionTabletContext.selectedStations.push(selectedStation.id);
            this.actionTabletContext.currentlyActiveStation = selectedStation.id;
          }
        }
        this.storeSettings();
      }
    );
  }

  private isStationAlreadyInContext(station: Station): boolean {
    return this.actionTabletContext.selectedStations.find(s => s === station.id) != null;
  }

  private findStoredSelection(): number {
    const settings = this.componentSelectionStorageService.getWidgetSelection(STORAGE_KEY, this.actionTabletContext.widgetIdentifier);
    return settings?.currentlyActiveStation;
  }

  public isStationSelected(stationId: number) {
    if (this.actionTabletContext == null) {
      return;
    }

    return this.actionTabletContext.currentlyActiveStation === stationId;
  }

  public closeStation(stationId: number) {
    const indexOf = this.actionTabletContext.selectedStations.indexOf(stationId);
    this.actionTabletContext.selectedStations.splice(indexOf, 1);
    this.storeSettings();

    this.actionTabletContext.currentlyActiveStation = null;

    if (indexOf === 0) {
      this.selectStation(this.actionTabletContext.selectedStations[0]);
    } else {
      this.selectStation(this.actionTabletContext.selectedStations[indexOf - 1]);
    }
  }

  public selectStation(stationId: number) {
    this.actionTabletContext.currentlyActiveStation = stationId;
    this.storeSettings();
  }
}
